module.exports = __webpack_public_path__ + "assets/img/driver-btn-7ebe4e7e.png";